<template>
  <v-row class="pt-0" style="height: 100%;">
    <Teleport to="#settings-group-header">
      Создание магазина
    </Teleport>  
    
    <v-col cols="12">
      <Shop :loading="loading" :shops="shops" 
        @onAdd="newShop"
        @onSearch="onSearch"
        @onGetList="getShopsList"
        @onClickRow="onClickRow"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Teleport from 'vue2-teleport';
import Shop from '@/components/shops/Shops.vue'

export default{

  data: () => ({
    loading: false
  }),

  computed:{
    ...mapGetters('data', ['shops'])
  },

  methods: {
    ...mapActions('data', ['shop_list','shop_search']),

    onClickRow(item){
      this.$router.push({name: 'ShopEdit', params: {shop_id: item.id}})
    },

    newShop(){
      this.$router.push('/shops/add');
    },

    async onSearch(search){
      this.loading = true;
      if(search.query !== "")
        await this.shop_search(search);
      else
        this.getShopsList();
      this.loading = false;
    },

    async getShopsList(options){
      this.loading = true;
      await this.shop_list(options);
      this.loading = false;
    },
  },

  async mounted(){
    this.loading = true;
    await this.shop_list()
    this.loading = false;
  },

  components:{
    Shop, Teleport
  }
}
</script>